export function loadUserData(ctx, payload, done) {
    ctx.dispatch('LOAD_USER_DATA', payload);
    done();
}



// WEBPACK FOOTER //
// ./js/launch/actions/userActions.js